import React, {useEffect, useRef, useState} from 'react';
import useApi from "../../hooks/useApi";
import {Button} from "devextreme-react/button";
import ILookupItem from "../../models/ILookupItem";
import IProduitCategorie from "../../models/IProduitCategorie";
import ListProduitItem from "./list-produit-item";
import ICatalogue from "../../models/ICatalogue";
import Guid from "../../models/Guid";
import './liste-unite-produit-disponible.css';

interface IListProduitProps {
    isModeModify?: boolean
    isReservation?: boolean
}

const ListProduitsDisponible = ({isModeModify, isReservation}: IListProduitProps) => {
    const {data: produitCategories, getData: getProduitCategories} = useApi<IProduitCategorie[]>(`produitcategorie/CategoriesProduitsAvecProduitActif?pourReservation=${isReservation}`)
    const [forceRefresh, setForceRefresh] = useState(false)
    const [selectedProduitCategorie, setSelectedProduitCategorie] = useState<ICatalogue[]>()

    useEffect(() => {
        getProduitCategories();
    }, [])

    return (
        <div style={{display: "flex", flexDirection: "column", height: "100%"}}>
            <div style={{display: "flex", flexDirection: "column", gap: "0.2rem", padding: "1rem 0.5rem", overflowY: "auto", flex: "1 0"}}>
                {produitCategories?.map((produitCategorie) => {
                    if (produitCategorie.idProduitCategorie?.equals(Guid.empty)) return null;
                    return (<ListProduitItem
                        key={produitCategorie.idProduitCategorie?.toString()}
                        produitCategorie={produitCategorie}
                        refresh={forceRefresh}
                        selectedProduit={selectedProduitCategorie || []}
                        setSelectedProduit={setSelectedProduitCategorie}
                        isModeModify={isModeModify}
                        isReservation={isReservation}
                    />)
                })}
            </div>
        </div>
    );
}

export default ListProduitsDisponible;
